@if(media && media.length){
<div class="_product-view-media">
    @if(client.isL || client.isX){
    <div class="pos-relative flex">
        <carousel class="_carousel inline-flex"
                  [style.width.px]="'77'"
                  [loop]="false"
                  [autoplay]="false"
                  [slidesPerView]="'auto'"
                  [direction]="'vertical'"
                  [navigation]="{
                    addIcons: false,
                    nextEl: '.thumb-carousel-next',
                    prevEl: '.thumb-carousel-prev'
                  }"
                  [spaceBetween]="16"
                  [scrollbar]="false">
            @for (item of media; track item._trackId; let i = $index) {
            <ng-template carouselSlide>
                <button type="button"
                        class="inline-flex _image-container"
                        [style.width.px]="77"
                        [class._selected]="activeIndex() === i"
                        (click)="activeIndex.set(i)">
                    <image-video class="inline-block pos-relative _z--1"
                                 [source]="item"
                                 [alt]="source?.name"
                                 [ratio]="1"
                                 [width]="77"
                                 [photoswipeOption]="getPhotoswipeOptions(i)" />
                </button>
            </ng-template>
            }
        </carousel>

        <!-- prev thumb carousel arrow -->
        <button class="swiper-arrow-button thumb-carousel-prev left-50 z-1 pos-absolute inline-flex"
                [style.top.rem]="-1.5"
                aria-label="Previous slide"
                type="button">
            <i class="icon-chevron-up col-w"
               aria-hidden="true"></i>
        </button>

        <!-- next thumb carousel arrow -->
        <button class="swiper-arrow-button thumb-carousel-next left-50 z-1 pos-absolute inline-flex"
                [style.bottom.rem]="-1.5"
                aria-label="Next slide"
                type="button">
            <i class="icon-chevron-down col-w"
               aria-hidden="true"></i>
        </button>
    </div>
    <div class="pos-relative w-12 _image-container ratio-1-1">
        @if (source()?.label; as label) {
        <badge [color]="source()?.labelColor || 'transparent'"
               class="_label inline-block pos-absolute top-0 left-0 z-2">{{ label }}</badge>
        }
        <ng-container [ngTemplateOutlet]="mainImageTemplate" />
    </div>
    }@else{
    <carousel class="_carousel inline-flex w-12"
              [loop]="false"
              [autoplay]="false"
              [slidesPerView]="'auto'"
              [spaceBetween]="8"
              [scrollbar]="true">
        @for (item of media; track item._trackId; let i = $index) {
        <ng-template carouselSlide>
            <button class="inline-flex _image-container"
                    [style.width.px]="60"
                    [class._selected]="activeIndex() === i"
                    (click)="activeIndex.set(i)">
                <image-video class="inline-block pos-relative _z--1"
                             [source]="item"
                             [alt]="source()?.name"
                             [ratio]="1"
                             [width]="60"
                             [photoswipeOption]="getPhotoswipeOptions(i)" />
            </button>
        </ng-template>
        }
    </carousel>
    <div class="flex-grow wrap">
        <div class="pos-relative _image-container ratio-1-1 w-12">
            <product-wishlist-toggle class="pos-absolute top-0 right-0 z-2 _wishlist-toggle"
                                     [productId]="source()?.id" />
            @if (source()?.label; as label) {
            <badge [color]="source()?.labelColor || 'transparent'"
                   class="_label inline-block pos-absolute top-0 left-0 z-2">{{ label }}</badge>
            }
            <ng-container [ngTemplateOutlet]="mainImageTemplate" />
        </div>
    </div>
    }
</div>


<!-- zoom in lightbox -->
<photoswipe-lightbox [photoswipeOptions]="photoswipeOptions"
                     (photoswipeStateChange)="onPhotoswipeStateChange($event)"
                     (photoswipeChanged)="onPhotoswipeChanged($event)">
    <ng-template #photoswipeThumbnailTpl
                 let-item
                 let-index="index"
                 let-photoswipe="photoswipe">
        @if (item.source) {
        <div class="pos-relative bg-col-5 pswp__thumb"
             [class.is-active]="item === photoswipe?.currItem"
             (click)="photoswipe?.goTo(index)">
            <div class="fill overflow-hidden"
                 [class._hasVideoZoom]="item.onFocusOnly">
                <img [fill]="true"
                     [ratio]="1"
                     [dfImage]="item.source"
                     [alt]="source()?.data?.name || ''">
            </div>
        </div>
        }
    </ng-template>

    <ng-template #photoswipeIconCloseTpl>
        <i class="icon-arrow-left inline-block va-m"
           aria-hidden="true"></i>
        <span class="inline-block overflow-hidden no-wrap">&nbsp;&nbsp;{{'Back to item' | translate}}</span>
    </ng-template>

    <ng-template #photoswipeIconPrevTpl />

    <ng-template #photoswipeIconNextTpl />
</photoswipe-lightbox>
}

<ng-template #mainImageTemplate>
    @for(item of media; track item._trackId; let i = $index) {
    <image-video class="block _main-image z-1"
                 [class._hidden]="activeIndex() !== i"
                 [source]="item"
                 [alt]="source()?.name"
                 [ratio]="1"
                 [photoswipeOption]="getPhotoswipeOptions(i)" />
    }
</ng-template>
